import React, { useState, useEffect, createRef, useContext } from "react";

import { useTranslation } from "react-i18next";

import TabOverview from "../components/TabOverview";
import TabTraining from "../components/TabTraining";
import CourseCalendar from "../components/CourseCalendar";

import ModalFull from "../components/ModalFull";

import Intro from "../components/Intro";
import Button from "../components/common/Button";
import Tab from "../components/Tab";

//import collect from "collect.js";

import "swiper/css";

// import { EnvContext } from "../context/env-context";
import { LangContext } from "../context/lang-context";

import { useTabStore } from "../store/tab-store";
//import { useInfoStore } from "../store/info-store";

import clsx from "clsx";

import openUrl from "../utilities/openUrl";

// import parseSources from "../utilities/parseSources";

function PageStudio(props) {
  const { t } = useTranslation();
  const contentRef = createRef();
  
  // const env = useContext(EnvContext);
  const lang = useContext(LangContext);

  const langFull = {de: "german", en: "english", fr: "french", it: 'italian'};

  //const { setCourses } = useInfoStore();
  const studioinfo = props.studioinfo ? JSON.parse(props.studioinfo) : false;

  const [state, setState] = useState({
    id: props.id,
    shopId: props.shopId,
    clubtour: props.clubtour,
    tourFallback: props.tourFallback,
    is_livegroupfitness: props.lgf,
    base: {
      loaded: studioinfo ? true :false,
      error: false,
      data: studioinfo ? studioinfo : {},
    },
    courses: {
      loaded: false,
      error: false,
      data: {},
    },
    prices: {
      loaded: studioinfo ? true :false,
      error: false,
      data: studioinfo ? studioinfo.bestOffer : {},
    },
  });


  const [tab, setTab] = useTabStore((state) => [state.tab, state.setTab]);

  const [trainingModalOpen, setTrainingModalOpen] = useState(false);
  const closeTrainingModal = () => {
    setTrainingModalOpen(false);
  };


  const onTabClick = (targetTab) => {
    setTab(targetTab);
    //contentRef?.current?.scrollIntoView({ behavior: "smooth", block: 'start'});
    let el = document.querySelector('.st-wrapper');
    el.scrollIntoView({ behavior: "smooth", block: 'start'});
  };

  useEffect(() => {
    const body = document.body;
    if (tab === "courses") {
      body.classList.add("is-locked");
    } else {
      body.classList.remove("is-locked");
    }
  }, [tab]);

  useEffect(() => {
    if (!state.base.loaded) {
      const id = props.id;

      let url = null;
      let headers = {};
      url =
        "https://www.puregym.swiss/wp-json/clubpage/v1/data?id=" +
        id +
        "&lang=" +
        lang.lang;

      if (url) {
        fetch(url, {
          headers,
          mode: "cors",
        })
          .then((res) => res.json())
          .then(
            (result) => {
              setState((state) => ({
                ...state,
                base: {
                  loaded: true,
                  data: result.data,
                },
              }));
              setState((state) => ({
                ...state,
                prices: {
                  loaded: true,
                  data: result.data.bestOffer,
                },
              }));
            },
            (error) => {
              setState((state) => ({
                ...state,
                base: {
                  loaded: false,
                  error,
                },
              }));
            }
          );
      }
    }
  });
  
  const [isScrolled, setIsScrolled] = useState(false);
  const memberLink = state.base.data.links.custom_link?.[lang.lang] ? state.base.data.links.custom_link[lang.lang] :  state.base.data.links.exerp+'/join/plan?center='+ props.shopId + '&lang='+langFull[lang.lang];
  

  useEffect(() => {
    const handleScroll = () => {
      if (!isScrolled && window.scrollY > window.innerHeight * 0.5)
        setIsScrolled(true);
      else if (window.scrollY < window.innerHeight * 0.5) setIsScrolled(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled, setIsScrolled]);
  //let options = (typeof props.options !== 'undefined') ? JSON.parse(props.options) : {};
  return (
    <>
      {state.base.loaded && (
        <>
          <Intro
            data={state.base.data}
            lgf={props.lgf}
            agId={props.id}
            shopId={state.shopId}
            lang={lang}
          />
          <nav className="tw-sticky tw-top-[var(--pg-header-height)] tw-z-40 tw-h-12 tw--mt-12 md:tw-h-14 md:tw--mt-14 tw--mb-12 tw-flex tw-bg-gray-light tw-text-black tw-m-auto tw-max-w-screen-lg lg:tw-rounded-t-xl tw-overflow-hidden">
            <Tab
              onClick={() => onTabClick("overview")}
              label={t("nav.overview")}
              active={tab === "overview"}
            />
            {state.is_livegroupfitness !== "0" &&(
             <Tab
                onClick={() => openUrl(state.base.data.links.exerp+'/booking?centers='+state.shopId+'&lang='+langFull[lang.lang]) }
                label={t("nav.courses")}
                className="tw-border-l tw-border-r tw-border-gray-medium"
              />
            )}
            <Tab
              onClick={() => onTabClick("training")}
              label={t("nav.training")}
              active={tab === "training"}
            />
          </nav>

          <div ref={contentRef} className="tw-pt-12 st-wrapper tw-scroll-mt-12">
            <TabOverview
              bgmap={props.bgmap}
              yt={props.yt}
              clubtour={state.clubtour}
              data={state.base.data}
              prices={state.prices.data}
              shopId={state.shopId}
              tourFallback={state.tourFallback}
              isLivegroupfitness={state.is_livegroupfitness}
              setTrainingModalOpen={setTrainingModalOpen}
              options={props.options}
            />
            {state.is_livegroupfitness && (
              <ModalFull
                isOpen={trainingModalOpen}
                closeModal={closeTrainingModal}
                title={t("nav.courses")}
                innerClassName="tw-bg-gray-light"
                scrollable={false}
              >
                <CourseCalendar data={state} shopId={state.shopId} />
              </ModalFull>
            )}
            <TabTraining data={state.base.data} lang={lang.lang} />
          </div>

          {!state.base.data.status.isComingSoon && (
            <div
              className={clsx(
                "tw-sticky tw-inset-x-0 tw-bottom-0 tw-z-20 tw-px-5 tw-py-3 tw-bg-teal tw-text-white tw-transition-[opacity,visibility] tw-duration-300",
                { "tw-invisible tw-opacity-0": !isScrolled },
                { "tw-visible tw-opacity-100": isScrolled }
              )}
            >
              <div className="tw-flex tw-items-center tw-space-x-2 tw-pb-safe-bottom tw-max-w-screen-lg tw-m-auto">
                <div className="tw-flex-1 lg:tw-flex-none">
                  <div className="tw-inline-block">
                    <span className="tw-text-xs tw-uppercase">
                      {t("cta.from")}
                    </span>
                    <span className="tw-font-condensed tw-font-black tw-text-2xl lg:tw-text-4xl tw-uppercase tw-italic tw-ml-2">
                      CHF {state.base.data.bestOffer.core12/12} 
                    </span>
                    <span className="tw-text-xs tw-uppercase tw-ml-1">
                      {t("overview.monthly")}
                    </span>
                  </div>
                </div>
                <div className="tw-font-condensed tw-font-black tw-text-lg tw-uppercase tw-hidden tw-flex-1 tw-text-center lg:tw-block">
                  {t("cta.claim")}
                </div>
                <Button
                  title={state.base.data.status.isPresale? t("buttons.interest"):t("buttons.register")}
                  color="orange"
                  type="fill"
                  size="large"
                  href={memberLink}
                  className="tw-flex-1 lg:tw-flex-none"
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default PageStudio;
